<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-card elevation="0" class="mt-2" max-width="1000">
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="form.title"
                label="제목"
                clearable
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="form.content"
                label="내용"
                clearable
                :rules="[rules.required]"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div @drop.prevent="addDropFile" @dragover.prevent>
                <v-file-input
                  chips
                  multiple
                  label="서류 첨부"
                  @change="changeFiles"
                  :value="files"
                  truncate-length="15"
                ></v-file-input>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn elevation="0" outlined color="primary" to="/data/list">
            취소
          </v-btn>
          <v-btn elevation="0" color="primary" @click="onSubmit">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-snackbar v-model="snackbar.show" timeout="1000">
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import uploadFiles from "@/mixins/uploadFiles";

export default {
  data() {
    return {
      form: {
        topYn: "N",
        title: "",
        content: "",
      },
      snackbar: { show: false, message: "" },
      valid: true,
      rules: {
        required: value => !!value || "필수 항목입니다.",
      },
    };
  },
  computed: {
    isModify() {
      return this.$route.params.id ? true : false;
    },
  },
  mixins: [uploadFiles],
  methods: {
    getContents(value) {
      this.form.content = value;
    },
    async onSubmit() {
      console.log("submit");
      this.$refs.form.validate();
      if (!this.valid) return false;

      // let res;
      // try {
      //   if (this.isModify) {
      //     // 수정
      //   } else {
      //     // 등록
      //   }

      //   if (res.data.ret === 1) {
      //     this.snackbar.message = "저장에 성공했습니다.";
      //     this.snackbar.show = true;

      //     setTimeout(() => {
      //       const path = this.$route.params.id
      //         ? `/approval/view/${this.$route.params.id}`
      //         : `/approval/view/${res.data.id}`;

      //       this.$router.push(path);
      //     }, 500);
      //   } else {
      //     this.snackbar.message = "저장에 실패했습니다.";
      //     this.snackbar.show = true;
      //   }
      // } catch (error) {
      //   console.error(error.response.data.message);
      // }
    },
  },
};
</script>

<style></style>
